import React, { useState, useEffect, useRef } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import useInView from './useInView';
import reveal from './reveal.module.css';
import styles from './Galeria.module.css';

// Edita aquí tus fotos y descripciones.
const fotos = [
  {
    src: '/images/album1.png',
    titulo: 'Inauguración',
    descripcion: 'Inauguración de nuestra Planta de Biogás junto al Alcalde de Barranquilla Alejandro Char Chaljub.',
  },
  {
    src: '/images/album2.png',
    titulo: 'Equipo de trabajo',
    descripcion: 'Visita del programa de Ingenería Ambiental de la Universidad de la Guajira.',
  },
  {
    src: '/images/album3.png',
    titulo: 'Proyectos en ejecución',
    descripcion: 'Finalización de la Construcción de la Planta de Biogás en Barranquilla.',
  },
  {
    src: '/images/album4.png',
    titulo: 'Capacitación',
    descripcion: 'Capacitación de Gestión de Residuos en el Relleno Sanitario Equipo Comercial y Operativo.',
  },
];

const AUTOPLAY_MS = 5000;

function Galeria() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const [ref, inView] = useInView(0.2);
  const touchStartX = useRef(null);

  const total = fotos.length;

  // Autoplay: avanza solo si la sección está visible y no está pausada.
  // Usa el updater funcional para no depender de "index" y evitar reinicios.
  useEffect(() => {
    if (paused || !inView) return undefined;
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % total);
    }, AUTOPLAY_MS);
    return () => clearInterval(id);
  }, [paused, inView, total]);

  const goTo = (i) => {
    setIndex(((i % total) + total) % total);
  };

  const next = () => goTo(index + 1);
  const prev = () => goTo(index - 1);

  // Swipe táctil para móvil.
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    const threshold = 50; // px mínimos para contar como swipe
    if (delta > threshold) {
      prev();
    } else if (delta < -threshold) {
      next();
    }
    touchStartX.current = null;
  };

  return (
    <section className={styles.section} ref={ref}>
      <div className={styles.container}>
        <div
          className={`${styles.header} ${reveal.reveal} ${
            inView ? reveal.visible : ''
          }`}
        >
          <span className={styles.eyebrow}>Galería</span>
          <h2 className={styles.title}>Momentos que nos definen</h2>
        </div>

        <div
          className={`${styles.carousel} ${reveal.reveal} ${
            inView ? reveal.visible : ''
          }`}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          <div className={styles.viewport}>
            <div
              className={styles.track}
              style={{ transform: `translateX(-${index * 100}%)` }}
            >
              {fotos.map((foto, i) => (
                <div className={styles.slide} key={i}>
                  <img
                    src={foto.src}
                    alt={foto.titulo}
                    className={styles.image}
                    loading="lazy"
                  />
                  <div className={styles.caption}>
                    <h3 className={styles.captionTitle}>{foto.titulo}</h3>
                    <p className={styles.captionText}>{foto.descripcion}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            type="button"
            className={`${styles.nav} ${styles.navPrev}`}
            onClick={prev}
            aria-label="Anterior"
          >
            <FiChevronLeft />
          </button>

          <button
            type="button"
            className={`${styles.nav} ${styles.navNext}`}
            onClick={next}
            aria-label="Siguiente"
          >
            <FiChevronRight />
          </button>

          <div className={styles.dots}>
            {fotos.map((foto, i) => (
              <button
                type="button"
                key={i}
                className={`${styles.dot} ${i === index ? styles.dotActive : ''}`}
                onClick={() => goTo(i)}
                aria-label={`Ir a la foto ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Galeria;